import Component from 'flarum/common/Component';
import on from './gate';
export default class BuildStatus extends Component {
  view() {
    if (!on()) return null;
    const progress = this.attrs.progress;
    return m("p", {
      className: "Challenge-buildStatus",
      role: "status"
    }, "Building your Learn page", progress ? ': ' + progress.replace(/[.…]+$/u, '') : '', m("span", {
      className: "Challenge-buildDots",
      "aria-hidden": "true"
    }, m("span", null, "."), m("span", null, "."), m("span", null, ".")));
  }
}